import Swal from 'sweetalert2'
import {
  IconPaths,
  showAlertLoading,
  showError,
  stringifyQueryFilters,
  validateDateRange,
} from '../../../../../../../_metronic/helpers'
import { Button } from '../../../../../../components'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { useListFilters } from '../../core/ListFiltersProvider'
import { FileDownloadResponse } from '../../core/_models'
import { getCsv, getPdf } from '../../core/_requests'

type Props = {
  /** Chamado quando falta o período (campo + datas): a busca destaca os campos obrigatórios. */
  onPeriodoIncompleto: () => void
}

/** Exportação do relatório (PDF e CSV) — exige o período completo e válido. */
export const RelatorioListToolbar = ({ onPeriodoIncompleto }: Props) => {
  const { state } = useQueryRequest()
  const { filters } = useListFilters()

  const periodoValido =
    !!(filters.range && filters.dataInicial && filters.dataFinal) &&
    !validateDateRange(filters.dataInicial, filters.dataFinal, { maxRangeDays: 31 }).error

  // Mesma busca da tabela, sem paginação/ordenação.
  const exportar = async (baixar: (query: string) => Promise<FileDownloadResponse>) => {
    if (!periodoValido) {
      onPeriodoIncompleto()
      return
    }

    const query = [stringifyQueryFilters(state.filters), state.search && `search=${state.search}`]
      .filter(Boolean)
      .join('&')

    try {
      showAlertLoading()
      const { data } = await baixar(query)
      Swal.close()
      window.open(data.URL, '_blank')
    } catch (error) {
      showError(error)
    }
  }

  const titulo = periodoValido ? undefined : 'Informe o período para exportar'

  return (
    <>
      <Button
        variant='secondary-outline'
        icon={IconPaths.Pdf}
        onClick={() => exportar(getPdf)}
        title={titulo}
      >
        Exportar PDF
      </Button>
      <Button
        variant='secondary-outline'
        icon={IconPaths.Csv}
        onClick={() => exportar(getCsv)}
        title={titulo}
      >
        Exportar CSV
      </Button>
    </>
  )
}
